import React from 'react';
import ReactDOM from 'react-dom/client';
import { ConfigProvider, theme } from 'antd';

import App from './App';

import './index.css';

const root = ReactDOM.createRoot(
	document.getElementById('root') as HTMLElement
);

root.render(
	<ConfigProvider
		theme={{
			algorithm: theme.darkAlgorithm
		}}
	>
		<App />
	</ConfigProvider>
);